import React from 'react';
import { Link } from 'react-router-dom';
import { Truck } from 'lucide-react';

/** Shown when the server says this account is not a driver at the chosen site (403 "Driver access required"). */
export default function DriverOnlyNotice() {
  return (
    <div className="m-4 bg-surface border border-surface-border rounded-lg p-8 text-center" data-testid="mobile-driver-only">
      <Truck className="w-10 h-10 mx-auto text-ink-subtle mb-3" aria-hidden="true" />
      <p className="font-display text-base text-ink">Delivery jobs are for driver accounts</p>
      <p className="text-sm text-ink-muted mt-1">Ask an admin to add the driver role for this site, or pick another site.</p>
      <Link to="/mobile/dashboard" className="inline-flex items-center mt-4 min-h-[44px] px-4 rounded-lg border border-surface-border text-ink">Back to home</Link>
    </div>
  );
}
